import Vue from 'vue';
import Router from 'vue-router';
import AppHeader from './layout/AppHeader';
import AppFooter from './layout/AppFooter';
import Index from './modules/portal/Index';
import notFound from './views/404'
Vue.use(Router);

const ValidaNfse = Vue.component('valida-nfse', {
  template: '',
  render(createElement, context) {
    const token = this.$router.currentRoute.query.chave || null
    const modulo = this.$router.currentRoute.query.modulo
    if(modulo === 'certidao_negativa'){
      const prefeitura = this.$router.currentRoute.query.pref
      const certidao = this.$router.currentRoute.query.cer
      const numero = this.$router.currentRoute.query.num
      const documento = this.$router.currentRoute.query.doc
      const pessoa = this.$router.currentRoute.query.pes
      window.location = `${process.env.VUE_APP_JANELA_URI_VALIDA_QRCODE_NOTA}/actions/controlService.php?tipoReq=qrCode&certidao=${certidao}&codprefeitura=${prefeitura}&numero=${numero}&documento=${documento}&pessoa=${pessoa}`
    }
    if (modulo === 'nota_eletronica'){
      window.location = `${process.env.VUE_APP_JANELA_URI_VALIDA_QRCODE_NOTA}/documentos/nota_eletronica/nfse.php?codChave=${token}`
    }
    return true
  }
})

export default new Router({
  linkExactActiveClass: 'active',
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'portal',
      components: {
        header: AppHeader,
        default: Index,
        footer: AppFooter
      }
    },
    {
      path: '/ws_qrcode.php',
      name: 'valida-nfse',
      component: ValidaNfse
    },
    {
      path: '*',
      name: '404',
      components: {
        default: notFound,
        footer: AppFooter
      }
    },
  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});
